import { hbs } from 'ember-cli-htmlbars';
export default hbs("<svg class=\"nw-icon\" fill=\"currentColor\" ...attributes>\n  <use xlink:href=\"#{{@icon}}\"></use>\n  {{yield}}\n</svg>")